import Accounts from './accounts'
import Appointments from './appointments'
import Availabilities from './availabilities'
import Shifts from './shifts'
import ServiceRegions from './serviceRegions'
import WaitingRoom from './waitingRoom'
import OpenTimes from './openTimes'
import waitLists from './waitList'
import visits from './visits'
import formCompletion from './formCompletion'

export default class Organizations {
    constructor(options){
        if(options){
            this.client = options.client
        }
    }
    get accounts(){
        return new Accounts({client: this.client})
    }

    get appointments(){
        return new Appointments({client: this.client})
    }

    get shifts(){
        return new Shifts({client: this.client})
    }

    get availabilities(){
        return new Availabilities({client: this.client})
    }

    get serviceRegions(){
        return new ServiceRegions({client: this.client})
    }

    get waitingRoom(){
        return new WaitingRoom({client: this.client})
    }

    get openTimes(){
        return new OpenTimes({client: this.client})
    }

    get waitLists(){
        return new waitLists({client: this.client})
    }
    
    get visits(){
        return new visits({client: this.client})
    }
    /**
     * @returns {formCompletion}
     */
    get formCompletion(){
        return new formCompletion({client: this.client})
    }

// mark ***
    refreshSync(options){
        // /organizations/:id/refresh-sync
        return this.client.put(`/refresh-sync`, options)
    }

// mark ***
    findByID(organizationID){
        return new Promise((resolve, reject)=>{
            try{
                const staq = {
                    organization: `/organizations/${organizationID}`,
                    appointmentTypes: `/appointment-types?active=true&withServiceTimes=true`,
                    administrators: `/administrators?active=true`,
                    customFields: `/custom-fields`
                }

                Promise.all(
                    Object.values(staq).map((url)=>(
                        this.client.get(url)
                    ))
                ).then((response)=>{
                    resolve({
                        data: Object.keys(staq).reduce((acc, key, i)=>{
                            acc[key] = response[i].data;
                            return acc;
                        }, {})
                    })
                }).catch((e)=>{
                    if(e.response.status == 401){
                        resolve({
                            data: {
                                error: true
                            }
                        }) 
                    }
                })
        
            }catch(error){
                reject(error)
            }
        })
    }
// mark ***
    findPatientDataByID(organizationID){
        return new Promise((resolve, reject)=>{
            try{
                const staq = {
                    classifications: `/classifications`,
                    breeds: `/breeds?active=true`,
                    genders: `/genders?active=true`
                }

                Promise.all(
                    Object.values(staq).map((url)=>(
                        this.client.get(url)
                    ))
                ).then((response)=>{
                    resolve({
                        data: Object.keys(staq).reduce((acc, key, i)=>{
                            acc[key] = response[i].data;
                            return acc;
                        }, {})
                    })
                }).catch((e)=>{
                    if(e.response.status == 401){
                        resolve({
                            data: {
                                error: true
                            }
                        }) 
                    }
                })
        
            }catch(error){
                reject(error)
            }
        })
    }
}


// WEBPACK FOOTER //
// ./lib/apiClient/organizations/index.js